/// <reference path="../../libs.ts" />
import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface IUpdateSuspendedDataAlertSettingParams {
  user: string;
  enabled: boolean;
}

export class UpdateSuspendedDataAlertSettingRequest extends Request<IUpdateSuspendedDataAlertSettingParams, IResult> {
  constructor(params: IUpdateSuspendedDataAlertSettingParams) {
    super('updateSuspendedDataAlertNotificationSetting', params);
  }
}
